// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2pHTW","empty":"ModalGraph_empty__310ff"};